import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { StaffPushMessageTemplate } from 'components/Templates'

const AppPush: FC = () => {
  return (
    <Layout headline={'通知履歴'} title={'通知履歴'}>
      <StaffPushMessageTemplate />
    </Layout>
  )
}

export default AppPush
